module.exports = __webpack_public_path__ + "media/née bpen gaan sà-daeng hâi doo ná tân pôo jà-rern.5c8541a7.mp3";